/* eslint-disable no-param-reassign */
import produce from 'immer';
import { SET_SOUND_RECOVER, SET_BASIC_TINNITUS_BALANCE, SET_FITTING_PUSH_BUTTON_FORM_REMOTE, SET_FITTING_PUSH_BUTTON, SET_FITTING_REC, SET_FITTING_VOLUME_BUTTON_FORM_REMOTE, SET_FITTING_VOLUME_BUTTON, SET_FITTING_VOLUME_BEHAVIOR, SET_FITTING_STARTUP, SET_FITTING_BEEP, SET_FITTING_CURVES_DATA, SET_FITTING_SETTING, SET_FREQUENCY_BAND_GROUP, SET_FITTING_MPO_DATA, SET_FITTING_GAIN_DATA, SET_BASIC_INITIAL_FITTING, SET_BASS_BOOST, SET_FITTING_COMPRESSION_DATA, SET_OPTIONAL_CURVE_TYPES, SET_FREQUENCY_COMPRESSION_INFO_AUDIBILITY, SET_ALL_PROGRAMS } from 'src/actions/fittingActions';
import { SET_SELECTED_UPDATERS } from './../actions/fittingActions';
import { SET_FREQUENCY_COMPRESSION_INFO, SET_FREQUENCY_COMPRESSION_INFO_ENABLE } from './../actions/fittingActions';
import { SET_FREQUENCY_COMPRESSION_INFO_CLARITY } from './../actions/fittingActions';
import { SET_EASING_SOFT_UPDATERS } from './../actions/fittingActions';
import { SET_EASING_SOFT_SELECT_UPDATERS } from './../actions/fittingActions';
import { SET_FREQUENCY_COMPRESSION_CURVE_INFO } from './../actions/fittingActions';
import { SET_AVAILABLE_UPDATERS } from './../actions/fittingActions';
import { SET_CUSTOM_PROGRAMS } from './../actions/fittingActions';


const initialState = {
    instrumentOption: {
        pushButton: null,
        volumeButton: null,
        volumeBehavior: null,
        startUp: null,
        beep: null,
    },
    setting: null,
    curves: null,
    realEarCalibration: null,
    frequencyBandGroup: null,
    mpoData: null,
    gainData: null,
    compressionData: null,
    //TK&GAIN
    easingSoftUpdaters: null,
    easingSoftSelectUpdaters: null,
    //可听度
    availableUpdaters: null,
    availableSelectUpdaters: null,
    basicInitialfitting: null,
    tinnitusBalance: null,
    soundRecover: null,
    bassBoost: null,
    optionalCurveTypes: null,
    //Gain&MPO
    selectUpdaters: null,
    //高频重塑
    frequencyCompression: null,
    frequencyCompressionCurveInfo: null,
    allPrograms: null,
    customPrograms: null,
};

const fittingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FITTING_PUSH_BUTTON:
        case SET_FITTING_PUSH_BUTTON_FORM_REMOTE: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.instrumentOption.pushButton = data;
            });
        }
        case SET_FITTING_VOLUME_BUTTON:
        case SET_FITTING_VOLUME_BUTTON_FORM_REMOTE: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.instrumentOption.volumeButton = data;
            });
        }
        case SET_FITTING_VOLUME_BEHAVIOR: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.instrumentOption.volumeBehavior = data;
            });
        }
        case SET_FITTING_STARTUP: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.instrumentOption.startUp = data;
            });
        }
        case SET_FITTING_BEEP: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.instrumentOption.beep = data;
            });
        }
        case SET_FITTING_CURVES_DATA: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.curves = data;
            });
        }
        case SET_FITTING_SETTING: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.setting = data;
            });
        }
        case SET_FITTING_REC: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.realEarCalibration = data;
            });
        }
        case SET_FREQUENCY_BAND_GROUP: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.frequencyBandGroup = data;
            });
        }
        case SET_FITTING_MPO_DATA: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.mpoData = data;
            });
        }
        case SET_FITTING_GAIN_DATA: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.gainData = data;
            });
        }
        case SET_FITTING_COMPRESSION_DATA: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.compressionData = data;
            });
        }
        case SET_BASIC_INITIAL_FITTING: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.basicInitialfitting = data;
            });
        }
        case SET_BASIC_TINNITUS_BALANCE: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.tinnitusBalance = data;
            });
        }
        case SET_SOUND_RECOVER: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.soundRecover = data;
            });
        }
        case SET_BASS_BOOST: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.bassBoost = data;
            });
        }
        case SET_OPTIONAL_CURVE_TYPES: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.optionalCurveTypes = data;
            });
        }
        case SET_SELECTED_UPDATERS: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.selectUpdaters = data;
            });
        }
        case SET_FREQUENCY_COMPRESSION_INFO: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.frequencyCompression = data;
            });
        }
        case SET_FREQUENCY_COMPRESSION_INFO_ENABLE: {
            const { enable, side } = action.payload;
            return produce(state, (draft) => {
                if (side === "both") {
                    draft.frequencyCompression.left.enabled = enable;
                    draft.frequencyCompression.right.enabled = enable;
                }
                else {
                    draft.frequencyCompression[side].enabled = enable;
                }
            });
        }
        case SET_FREQUENCY_COMPRESSION_INFO_AUDIBILITY: {
            const { value, side } = action.payload;
            return produce(state, (draft) => {
                if (side === "both") {
                    draft.frequencyCompression.left.audibility.value = value;
                    draft.frequencyCompression.right.audibility.value = value;
                }
                else {
                    draft.frequencyCompression[side].audibility.value = value;
                }
            });
        }
        case SET_FREQUENCY_COMPRESSION_INFO_CLARITY: {
            const { value, side } = action.payload;
            return produce(state, (draft) => {
                if (side === "both") {
                    draft.frequencyCompression.left.clarity.value = value;
                    draft.frequencyCompression.right.clarity.value = value;
                }
                else {
                    draft.frequencyCompression[side].clarity.value = value;
                }
            });
        }
        case SET_EASING_SOFT_UPDATERS: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.easingSoftUpdaters = data;
            });
        }
        case SET_EASING_SOFT_SELECT_UPDATERS: {
            const { data } = action.payload;
            return produce(state, (draft) => {
                draft.easingSoftSelectUpdaters = data;
            });
        }
        case SET_FREQUENCY_COMPRESSION_CURVE_INFO:
            {
                const { data } = action.payload;
                return produce(state, (draft) => {
                    draft.frequencyCompressionCurveInfo = data;
                });
            }
        case SET_AVAILABLE_UPDATERS:
            {
                const { data } = action.payload;
                return produce(state, (draft) => {
                    draft.availableUpdaters = data;
                });
            }
        case SET_ALL_PROGRAMS:
            {
                const { data } = action.payload;
                return produce(state, (draft) => {
                    draft.allPrograms = data;
                });
            }
        case SET_CUSTOM_PROGRAMS:
            {
                const { data } = action.payload;
                return produce(state, (draft) => {
                    draft.customPrograms = data;
                });
            }
        default: {
            return state;
        }
    }
};

export default fittingReducer;
